import React from 'react';
import moment from "moment";
import { useGlobalState } from '../../../state';
import { isToday } from '../../../common/date';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit,farmType}) => {
    const [{user}] = useGlobalState();
    // Same rule as desktop: only admins can edit/delete entries older than today
    const canModify = !(user.role !== "ADMIN" && user.role !== "FARMADMIN" && !isToday(data.entryDate));

    const rows = [
        { label: 'Entry Date', value: moment(data.entryDate).format("DD-MM-YYYY"), inHeader: true, hideLabel: true },
        { label: 'Batch Name', value: data.batchName },
        ...(farmType === 2 ? [
            { label: 'Mortality', value: data.mortality },
            { label: 'Feed (Kg)', value: data.feedReceived },
            { label: 'Avg Weight', value: data.bodyWeight },
            { label: 'Water (L)', value: data.water },
            { label: 'Uniformity %', value: data.uniformity },
        ] : [
            { label: 'Egg Closing Stock (Trays)', value: data.eggClosingStock },
            { label: 'Mortality (Nos)', value: data.mortality },
            { label: 'Egg Sales (Trays)', value: data.eggSales },
            { label: 'Broken Egg (Nos)', value: data.eggBreakage },
            { label: 'Damaged Eggs (Nos)', value: data.damagedEggs },
            { label: 'Closing Feed (Kg)', value: data.closingFeed },
        ]),
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={data.shedName}
            rows={rows}
            menuItems={canModify ? menuItems : undefined}
        />
    );
};

export default Mobile;
